// Product gallery: thumbnails swap the main image in place (without
// JavaScript they open the full image), and the 3D button shows the
// product's live model (rendered hidden in the page; scenes.js mounts it
// once it is visible).
export function initGallery(root) {
  for (const g of root.querySelectorAll?.('[data-gallery]:not([data-gallery-init])') ?? []) {
    g.dataset.galleryInit = '';
    const stage = g.querySelector('.gallery-stage');
    const main = stage?.querySelector('img');
    if (!stage || !main) continue;
    const scene = stage.querySelector('[data-scene]');
    const select = (btn) => {
      for (const b of g.querySelectorAll('[data-gallery-thumb], [data-gallery-3d]')) {
        b.removeAttribute('aria-current');
        if (b.matches('[data-gallery-3d]')) b.setAttribute('aria-pressed', 'false');
      }
      if (btn.matches('[data-gallery-3d]')) btn.setAttribute('aria-pressed', 'true');
      else btn.setAttribute('aria-current', 'true');
    };
    for (const a of g.querySelectorAll('[data-gallery-thumb]')) {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        main.srcset = a.dataset.srcset || '';
        main.src = a.dataset.src;
        main.alt = a.dataset.alt || '';
        main.hidden = false;
        if (scene) scene.hidden = true;
        select(a);
      });
    }
    const btn3d = g.querySelector('[data-gallery-3d]');
    btn3d?.addEventListener('click', () => {
      if (!scene) return;
      main.hidden = true;
      scene.hidden = false;
      select(btn3d);
    });
  }
}
